import { render, staticRenderFns } from "./CopyrightSplitsCancel.vue?vue&type=template&id=1bacf79d&scoped=true&"
import script from "./CopyrightSplitsCancel.vue?vue&type=script&lang=js&"
export * from "./CopyrightSplitsCancel.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightSplitsCancel.vue?vue&type=style&index=0&id=1bacf79d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bacf79d",
  null
  
)

export default component.exports